import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { activityTierBenefitsDataProvider } from './dataProvider';

// 注册 activity/tierBenefits 模块的数据提供者
export function initActivityTierBenefitsDataProvider() {
  registerModuleDataProvider('activity-tier-benefit', activityTierBenefitsDataProvider);
}

// 自动初始化
initActivityTierBenefitsDataProvider();
